import axios from 'axios';
//import { setApiKey, expandLink} from "@short.io/client-node";

//setApiKey("sk_tlRKLaprU8RDPuAi");

/*const API_BASE_URL = await expandLink({
  query: {
    domain: "short.gy",
    path: "volassis"
  }
});*/

const API_BASE_URL = 'https://delaine-prosurrender-cleta.ngrok-free.dev/';

console.log('API_BASE_URL:', API_BASE_URL); // This will log the Promise object

// Create axios instance with default configuration 
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// test

// Add request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for logging and error handling
apiClient.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data, error.config?.url);
    return Promise.reject(error);
  }
);

const volassisAPI = {
  // Authentication
  signIn: async (email, password) => {
    try {
      const encodedEmail = btoa(email);
      const encodedPassword = btoa(password);
      const response = await apiClient.get(`/signIn?email=${encodedEmail}&password=${encodedPassword}`);
      return response.data;
    } catch (error) {
      console.error('SignIn error:', error);
      throw error;
    }
  },

  signUp: async (userData) => {
    try {
      const encodedData = {
        first_name: btoa(userData.firstName),
        last_name: btoa(userData.lastName),
        email: btoa(userData.email),
        password: btoa(userData.password),
        phone: btoa(userData.phone || ''),
        address: btoa(userData.address || ''),
        active: true,
        is_admin: false
      };
      
      const queryString = Object.keys(encodedData)
        .map(key => `${key}=${encodedData[key]}`)
        .join('&');
      
      const response = await apiClient.get(`/signUp?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('SignUp error:', error);
      throw error;
    }
  },

  getId: async (email) => {
    try {
      const encodedEmail = btoa(email);
      const response = await apiClient.get(`/getId?email=${encodedEmail}`);
      return response.data;
    } catch (error) {
      console.error('GetId error:', error);
      throw error;
    }
  },

  isAdmin: async (id) => {
    try {
      const response = await apiClient.get(`/isAdmin?id=${id}`);
      return response.data;
    } catch (error) {
      console.error('IsAdmin error:', error);
      throw error;
    }
  },

  // User Management
  getUserData: async (id) => {
    try {
      const response = await apiClient.get(`/getUserData?id=${id}`);
      return response.data;
    } catch (error) {
      console.error('GetUserData error:', error);
      throw error;
    }
  },

  updateUser: async (userData) => {
    try {
      const encodedData = {
        id: userData.id,
        first_name: btoa(userData.firstName),
        last_name: btoa(userData.lastName),
        email: btoa(userData.email),
        password: btoa(userData.password),
        phone: btoa(userData.phone || ''),
        address: btoa(userData.address || ''),
        active: userData.active
      };
      
      const queryString = Object.keys(encodedData)
        .map(key => `${key}=${encodedData[key]}`)
        .join('&');
      
      const response = await apiClient.get(`/updateUser?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('UpdateUser error:', error);
      throw error;
    }
  },

  getActiveUsers: async () => {
    try {
      const response = await apiClient.get('/getActiveUsers');
      return response.data;
    } catch (error) {
      console.error('GetActiveUsers error:', error);
      throw error;
    }
  },

  getInactiveUsers: async () => {
    try {
      const response = await apiClient.get('/getInactiveUsers');
      return response.data;
    } catch (error) {
      console.error('GetInactiveUsers error:', error);
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      const response = await apiClient.get(`/deleteUser?id=${id}`);
      return response.data;
    } catch (error) {
      console.error('DeleteUser error:', error);
      throw error;
    }
  },

  // Organization Management
  getOrganizations: async () => {
    try {
      const response = await apiClient.get('/getOrganizations');
      return response.data;
    } catch (error) {
      console.error('GetOrganizations error:', error);
      throw error;
    }
  },

  getInactiveOrganizations: async () => {
    try {
      const response = await apiClient.get('/getInactiveOrganizations');
      return response.data;
    } catch (error) {
      console.error('GetInactiveOrganizations error:', error);
      throw error;
    }
  },

  addOrganization: async (orgData) => {
    try {
      const encodedData = {
        org_id: orgData.orgId,
        name: btoa(orgData.name),
        category: btoa(orgData.category),
        email: btoa(orgData.email),
        phone: btoa(orgData.phone || ''),
        address: btoa(orgData.address || ''),
        active: orgData.active
      };
      
      const queryString = Object.keys(encodedData)
        .map(key => `${key}=${encodedData[key]}`)
        .join('&');
      
      const response = await apiClient.get(`/addOrganization?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('AddOrganization error:', error);
      throw error;
    }
  },

  updateOrganization: async (orgData) => {
    try {
      const encodedData = {
        org_id: orgData.orgId,
        name: btoa(orgData.name),
        category: btoa(orgData.category),
        email: btoa(orgData.email),
        phone: btoa(orgData.phone || ''),
        address: btoa(orgData.address || ''),
        active: orgData.active
      };
      
      const queryString = Object.keys(encodedData)
        .map(key => `${key}=${key === 'org_id' ? encodedData[key] : encodedData[key]}`)
        .join('&');
      
      const response = await apiClient.get(`/updateOrganization?${queryString}`);
      return response.data;
    } catch (error) {
      console.error('UpdateOrganization error:', error);
      throw error;
    }
  },

  deleteOrganization: async (orgId) => {
    try {
      const response = await apiClient.get(`/deleteOrganization?org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('DeleteOrganization error:', error);
      throw error;
    }
  },

  // Records Management
  getUserRecords: async (id, orgId, status) => {
    try {
      const response = await apiClient.get(`/getUserRecords?id=${id}&org_id=${orgId}&status=${status}`);
      return response.data;
    } catch (error) {
      console.error('GetUserRecords error:', error);
      throw error;
    }
  },

  getUserAggregateData: async (id) => {
    try {
      const response = await apiClient.get(`/getUserAggregateData?id=${id}`);
      return response.data;
    } catch (error) {
      console.error('GetUserAggregateData error:', error);
      throw error;
    }
  },

  getOrganizationRecords: async (orgId) => {
    try {
      const response = await apiClient.get(`/getOrganizationRecords?org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('GetOrganizationRecords error:', error);
      throw error;
    }
  },

  getOrganizationAggregateData: async (orgId) => {
    try {
      const response = await apiClient.get(`/getOrganizationAggregateData?org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('GetOrganizationAggregateData error:', error);
      throw error;
    }
  },

  getAggregateOrganizations: async (flag) => {
    try {
      const response = await apiClient.get(`/getAggregateOrganizations?flag=${flag}`);
      return response.data;
    } catch (error) {
      console.error('GetAggregateOrganizations error:', error);
      throw error;
    }
  },

  getAggregateUsers: async (orgId) => {
    try {
      const response = await apiClient.get(`/getAggregateUsers?org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('GetAggregateUsers error:', error);
      throw error;
    }
  },

  // Check-in/Check-out
  getCheckInDisable: async (userId, orgId) => {
    try {
      const response = await apiClient.get(`/checkInDisable?id=${userId}&org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('GetCheckInDisable error:', error);
      throw error;
    }
  },

  checkInCheckOut: async (userId, orgId) => {
    try {
      const response = await apiClient.post(`/checkinout`, { userId, orgId });
      return response.data;
    } catch (error) {
      console.error('CheckInCheckOut error:', error);
      throw error;
    }
  },

  // Hours Approval
  approveAllHours: async (id, orgId) => {
    try {
      const response = await apiClient.get(`/approveAllHours?id=${id}&org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('ApproveAllHours error:', error);
      throw error;
    }
  },

  isFullyApproved: async (id, orgId) => {
    try {
      const response = await apiClient.get(`/isFullyApproved?id=${id}&org_id=${orgId}`);
      return response.data;
    } catch (error) {
      console.error('IsFullyApproved error:', error);
      throw error;
    }
  },

  // Email
  sendEmail: async (to, subject, body) => {
    try {
      const encodedTo = btoa(to);
      const encodedSubject = btoa(subject);
      const encodedBody = btoa(body);
      
      const response = await apiClient.get(`/sendEmail?to=${encodedTo}&subject=${encodedSubject}&body=${encodedBody}`);
      return response.data;
    } catch (error) {
      console.error('SendEmail error:', error);
      throw error;
    }
  },

  // Export
  exportRecords: async (id, orgId, status) => {
    try {
      const response = await apiClient.get(`/exportRecords?id=${id}&org_id=${orgId}&status=${status}`);
      return response.data;
    } catch (error) {
      console.error('ExportRecords error:', error);
      throw error;
    }
  },

  // Session Logging
  logSession: async (userId, ip, login) => {
    try {
      const response = await apiClient.get(`/logSession?user_id=${userId}&ip=${ip}&login=${login}`);
      return response.data;
    } catch (error) {
      console.error('LogSession error:', error);
      throw error;
    }
  },

  // Error Logging
  logError: async (userId, email, errorData) => {
    try {
      const response = await apiClient.get(`/logError?user_id=${userId}&email=${email}&error_data=${errorData}`);
      return response.data;
    } catch (error) {
      console.error('LogError error:', error);
      throw error;
    }
  },

  // Test connection
  testConnection: async () => {
    try {
      const response = await apiClient.get('/getActiveUsers');
      return { success: true, message: 'Backend connection successful' };
    } catch (error) {
      return { success: false, message: 'Backend connection failed', error: error.message };
    }
  }
};

export { volassisAPI };